<script setup lang="ts">
import { useNavigation } from "#imports"
import { breakpointsTailwind, useBreakpoints } from '@vueuse/core'

const props = withDefaults(
    defineProps<{
        depthFooterNavigation?: number
        depthServiceNavigation?: number
    }>(),
    {
        depthFooterNavigation: 0,
        depthServiceNavigation: 0
    },
)

const footerNavigationComposable = useNavigation({ type: "footer-navigation" })
const footerNavigation = await footerNavigationComposable.loadNavigationElements({
    depth: props.depthFooterNavigation,
    includes: {
        category: [
            'id',
            'name',
            'children',
            'seoUrls',
            'externalLink',
            'linkNewTab',
            'linkType',
            'internalLink',
            'childCount',
            'type',
            'translated',
        ],
        seo_url: [
            'pathInfo',
            'seoPathInfo',
        ],
    },
})
const sharedOpenItemId = ref<string | null>(null)
provide('sharedAccordionState', sharedOpenItemId)

// Desktop detection using VueUse breakpoints (lg and larger = 1024px+)
const breakpoints = useBreakpoints(breakpointsTailwind, {
    ssrWidth: breakpointsTailwind.lg
})
const lgAndLarger = breakpoints.greaterOrEqual('lg')
</script>

<template>
    <footer>
        <h2 class="sr-only">{{ $t('layout.footer.hiddenHeadline') }}</h2>
        <div class="bg-base-200">
            <!-- Footer Top -->
            <div class="m-auto w-full max-w-8xl px-2 py-5 lg:py-8">
                <div class="flex flex-wrap justify-between">
                    <FooterSocialMedia />
                    <FooterNewsletter />
                </div>
            </div>
        </div>

        <!-- Footer Middle -->
        <div class="bg-base-200 mt-px">
            <div class="m-auto w-full max-w-8xl px-2">
                <div class="flex lg:flex-nowrap flex-wrap flex-col lg:flex-row items-start m-auto py-4 lg:py-12">
                    <FooterNavigation :navigation="footerNavigation" :lg-and-larger="lgAndLarger" />

                    <div class="flex flex-wrap flex-col justify-center gap-4 lg:ms-auto min-w-full lg:min-w-3xs lg:max-w-[490px]">
                        <ComponentAccordion
                            :items="[
                                { id: 'payment-methods', headline: $t('layout.footer.paymentMethodsHeadline') }
                            ]"
                            type="single"
                            headline-tag="h3"
                            :headline="$t('layout.footer.paymentMethodsHeadline')"
                            :no-accordion-on-desktop="lgAndLarger"
                        >
                            <template #payment-methods>
                                <FooterPaymentMethods />
                            </template>
                        </ComponentAccordion>

                        <NuxtLink
                            to="/widerruf-formular"
                            class="btn btn-primary w-fit lg:mt-4"
                        >
                            {{ $t('layout.footer.withdrawContract') }}
                        </NuxtLink>
                    </div>
                </div>
            </div>
        </div>

        <FooterBottom />
    </footer>
</template>
